import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  data: {
    employeeSelfMove: {
      selfMoveSuccessfull: string
    }
  }
}

export default function selfMove(spaceId: string): Promise<any> {
  return client.gql
    .query({ query, variables: { input: { toSpaceId: spaceId } } })
    .then(({ data: employeeSelfMove }: Payload) => ({
      ...employeeSelfMove,
    }))
}

const query = gql`
  mutation employeeSelfMove($input: EmployeeSelfMoveInput!) {
    employeeSelfMove(input: $input) {
      moveSuccesfull
    }
  }
`
